export default "__VITE_ASSET__Bt2YvOXy__"